import { NavLink } from 'react-router-dom';

const routes = [
    { to: '/1', label: <img src={require('../images/EN_01.svg').default} alt="SDG 1 Target" rel="1" id="btn-sdg-1-cover" />, order: 1 },
    { to: '/2', label: <img src={require('../images/EN_02.svg').default} alt="SDG 1 Target" rel="1" id="btn-sdg-1-cover" />, order: 2 },
    { to: '/5', label: <img src={require('../images/EN_05.svg').default} alt="SDG 1 Target" rel="1" id="btn-sdg-1-cover" />, order: 3 },
    { to: '/6', label: <img src={require('../images/EN_06.svg').default} alt="SDG 1 Target" rel="1" id="btn-sdg-1-cover" />, order: 4 },
    { to: '/10',label: <img src={require('../images/EN_10.svg').default} alt="SDG 1 Target" rel="1" id="btn-sdg-1-cover" />, order: 5 },
    { to: '/12',label: <img src={require('../images/EN_12.svg').default} alt="SDG 1 Target" rel="1" id="btn-sdg-1-cover" />, order: 6 },
    { to: '/14',label: <img src={require('../images/EN_14.svg').default} alt="SDG 1 Target" rel="1" id="btn-sdg-1-cover" />, order: 7 },
    { to: '/15',label: <img src={require('../images/EN_15.svg').default} alt="SDG 1 Target" rel="1" id="btn-sdg-1-cover" />, order: 8 }
   
];

const ContainerCover = props => {
    return (
        <div className="sdg-report-cover">
            <div className="title-holder">
                { props.social ? renderSocial() : '' }
                <h1 className="title-report">{ props.title }</h1>
                <h2>{ props.subtitle }</h2>
                { props.sdg ? renderSdgIcons(props.sdgIcon1, props.sdgIcon2, props.sdgIcon5, props.sdgIcon6, props.sdgIcon10, props.sdgIcon12, props.sdgIcon14, props.sdgIcon15) : '' }
            </div>
        </div>
    ) 
}

const renderSocial = () => {
    return(
        <div className="social-share social-mobile d-flex">
            <a href="http://www.facebook.com/share.php?u=https://www.fao.org/3/cc7088ar/online/cc7088ar.html" target="_blank" rel="noreferrer" className="social-a">
                <span className="facebook-icon-sec"></span>
            </a>
            <a href="https://twitter.com/share?url=https://www.fao.org/3/cc7088ar/online/cc7088ar.html" target="_blank" rel="noreferrer" className="social-a">
                <span className="twitter-icon-sec"></span>
            </a>
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=http%3A//www.fao.org/3/cc7088ar/online/cc7088ar.html" target="_blank" rel="noreferrer" className="social-a">
                <span className="linkedin-icon-sec"></span>
            </a>
            <a href={getDownloadLink()} className="btn btn-secondary btn-sm btn-download-pdf" target="_blank" rel="noreferrer">
            {getTextTranslation()}</a>
        </div>
    );
}

const getDownloadLink = () => {
    const l = document.getElementsByTagName('html')[0].getAttribute('lang');

    switch(l) {
        case 'en':
            return 'https://doi.org/10.4060/cc7088en';
        case 'es':
            return 'https://doi.org/10.4060/cc7088es';
        case 'fr':
            return 'https://doi.org/10.4060/cc7088fr';
        // case 'zh':
        //     return 'https://www.fao.org/3/cb6872zh/cb6872zh.pdf';
        // case 'ru':
        //     return 'https://www.fao.org/3/cc1403en/cc1403en.pdf';
        // case 'ar':
        //     return 'https://www.fao.org/3/cb6872ar/cb6872ar.pdf';
        default:
            return 'https://doi.org/10.4060/cc7088en';
    }

}

const getTextTranslation = () => {
    const l = document.getElementsByTagName('html')[0].getAttribute('lang');

    switch(l) {
        case 'en':
            return 'Download PDF';
        case 'es':
            return 'Descargar PDF';
        case 'zh':
            return '下载PDF文件';
        case 'ru':
            return 'Скачать PDF';
        case 'ar':
            return '(باللغة الإنجليزية) PDF قم بتنزيل الملف';
        case 'fr':
            return 'Télécharger le PDF';
        default:
            return 'Download PDF';
    }
}

const renderSdgIcons = () => {
    const links = routes.map(({ to, label, order }) => {
        return <NavLink  
            to={{
                pathname: to
            }}
            state={{ order: order }}
            key={to}>{label}
        </NavLink>
    }
    )
    return <div className="sdg-report-cover-icons">{links}</div>;
}





  


export default ContainerCover;
